import React from "react";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useHomeProducts } from "../../../api/queries/homeQueries";
import ProdCard from "../../../components/box/ProdCard";
import { UI } from "../../../config/ui";
import NetworkImage from "../../../components/image/NetworkImage";
import {
  icSwiperNextArrow,
  icSwiperPrevArrow,
} from "../../../components/image/image-src";

const RecommendAttractionPassSwiper: React.FC = () => {
  const { handleSlideChange, products } = useHomeProducts("PASS", "passes");

  return (
    <div className="relative">
      <Swiper
        modules={[Navigation]}
        onSlideChange={handleSlideChange}
        slidesPerView={2.3}
        spaceBetween={12}
        breakpoints={{
          [UI.sm]: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
        }}
        navigation={{
          nextEl: "#rcmd-pass-next",
          prevEl: "#rcmd-pass-prev",
        }}
        className="prod-card-swiper"
      >
        {products.map((product) => (
          <SwiperSlide
            className="white-shaddow-15 !h-auto sm:min-h-[300px]"
            key={product?.id}
          >
            <ProdCard {...product} contentOnly={true} home={true} />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="swiper-button-prev" id="rcmd-pass-prev">
        <NetworkImage src={icSwiperPrevArrow} alt="" />
      </div>
      <div className="swiper-button-next" id="rcmd-pass-next">
        <NetworkImage src={icSwiperNextArrow} alt="" />
      </div>
    </div>
  );
};
export default RecommendAttractionPassSwiper;
